import NotFoundComponent from './NotFoundComponent.vue';

export const notFoundRoutes = {
  path: '*',
  component: NotFoundComponent
};
